import styled from 'styled-components'

export const DashMain = styled.div`
  width: 100dvw;
  height: 100dvh;
  overflow: auto;
  background: ${(props) => props.theme.background};
`

export const DeskMain = styled.div`
  width: 100dvw;
  height: 100dvh;
  overflow-y: hidden;
  background: ${(props) => props.theme.background};
`
